import type { ReactNode } from 'react'
import { Box, keyframes, useMediaQuery } from '@mui/material'

const contentRefresh = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
`

type ClimateContentMotionProps = {
  transitionKey: string
  children: ReactNode
  minHeight?: number
  layout?: 'block' | 'inline'
  justifyContent?: 'flex-start' | 'center' | 'flex-end'
}

const ClimateContentMotion = ({
  transitionKey,
  children,
  minHeight,
  layout = 'block',
  justifyContent = 'flex-start',
}: ClimateContentMotionProps) => {
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)')
  const isInline = layout === 'inline'

  return (
    <Box
      sx={{
        width: '100%',
        minHeight,
        display: isInline ? 'flex' : 'block',
        alignItems: isInline ? 'center' : undefined,
        justifyContent: isInline ? justifyContent : undefined,
        overflow: 'hidden',
      }}>
      <Box
        key={transitionKey}
        sx={{
          width: isInline ? 'auto' : '100%',
          display: isInline ? 'inline-flex' : 'block',
          alignItems: isInline ? 'center' : undefined,
          animation: reduceMotion ? 'none' : `${contentRefresh} 220ms cubic-bezier(0.2, 0.8, 0.2, 1)`,
          transformOrigin: isInline ? 'center left' : 'top left',
          willChange: reduceMotion ? 'auto' : 'transform, opacity, filter',
        }}>
        {children}
      </Box>
    </Box>
  )
}

export default ClimateContentMotion
